import ar from './locale/ar';
import ca from './locale/ca';
import cs from './locale/cs';
import da from './locale/da';
import de from './locale/de';
import el from './locale/el';
import en from './locale/en';
import es from './locale/es';
import fi from './locale/fi';
import fr from './locale/fr';
import hu from './locale/hu';
import it from './locale/it';
import lv from './locale/lv';
import nl from './locale/nl';
import no from './locale/no';
import pl from './locale/pl';
import pt from './locale/pt';
import ro from './locale/ro';
import ru from './locale/ru';
import sk from './locale/sk';
import sr from './locale/sr';
import sv from './locale/sv';
import tr from './locale/tr';
import uk from './locale/uk';
import vi from './locale/vi';
import is from './locale/is';
import lt from './locale/lt';
import bg from './locale/bg';
import hr from './locale/hr';
import sl from './locale/sl';
import sq from './locale/sq';
import { createI18n } from 'vue-i18n';
import { syncDateFnsLocale } from 'dashboard/helper/dateFnsLocale';

export const i18nMessages = {
  ar,
  ca,
  cs,
  da,
  de,
  el,
  en,
  es,
  fi,
  fr,
  hu,
  it,
  lv,
  nl,
  no,
  pl,
  pt,
  ro,
  ru,
  sk,
  sr,
  sv,
  tr,
  uk,
  vi,
  is,
  lt,
  bg,
  hr,
  sl,
  sq,
};

const i18n = createI18n({
  legacy: false, // https://github.com/intlify/vue-i18n/issues/1902
  locale: 'en',
  messages: i18nMessages,
});

// vue-i18n throws `cannot support locale type` from every single `t()` call once the
// global locale is set to anything other than a string, which takes down the whole
// dashboard render. Callers often read the locale off a store record that may not be
// loaded yet, so ignore anything that isn't a usable locale code.
export const setI18nLocale = locale => {
  if (typeof locale !== 'string' || !locale) return;

  i18n.global.locale.value = locale;
  syncDateFnsLocale(locale);
};

export default i18n;
